"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.doSearch = exports.SearchBox = exports.ModuleMappingForSearchFilters = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classnames = _interopRequireDefault(require("classnames"));

var _phrase = _interopRequireDefault(require("../../../libs/translationsUtils/phrase"));

var _Analytics = _interopRequireDefault(require("../../analytics/Analytics"));

var _Add = _interopRequireDefault(require("@insided/shared/icons/Add"));

var _Cancel = _interopRequireDefault(require("@insided/shared/icons/Cancel"));

var _Search = _interopRequireDefault(require("@insided/shared/icons/Search"));

var _insidedDataStorage = require("@insided/shared/utils/insidedDataStorage");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ModuleMappingForSearchFilters = {
  community: 'category',
  'knowledge-base': 'kb_category'
};
exports.ModuleMappingForSearchFilters = ModuleMappingForSearchFilters;

var eventTracker = function eventTracker() {
  _Analytics.default.send('Homepage', 'Search clicked');
};

var doSearch = function doSearch(searchValue) {
  var _getInsidedData, _getInsidedData2;

  if (!searchValue) return;
  var searchParams = new URLSearchParams();
  searchParams.set('q', searchValue);
  var categoryPath = (_getInsidedData = (0, _insidedDataStorage.getInsidedData)('search')) === null || _getInsidedData === void 0 ? void 0 : _getInsidedData.categoryPath;
  var moduleName = (_getInsidedData2 = (0, _insidedDataStorage.getInsidedData)('search')) === null || _getInsidedData2 === void 0 ? void 0 : _getInsidedData2.module;

  if (categoryPath) {
    if (moduleName && Object.keys(ModuleMappingForSearchFilters).includes(moduleName)) {
      // @ts-expect-error
      searchParams.set(ModuleMappingForSearchFilters[moduleName], categoryPath);
    }
  }

  window.location.href = (0, _absoluteUrlRuntime.resolveUrl)("/search?".concat(searchParams.toString()));
};

exports.doSearch = doSearch;

var getSearchQueryFromInput = function getSearchQueryFromInput(searchString) {
  var searchQuery = {
    q: searchString
  };
  var eventUrlPattern = /https?:\/\/.+\/events\/.+-(\d+)$/;
  var eventUrl = eventUrlPattern.exec(searchString);
  var productUpdateUrlPattern = /https?:\/\/.+\/product-updates\/.+-(\d+)$/;
  var productUpdateUrl = productUpdateUrlPattern.exec(searchString);
  var ideaUrlPattern = /https?:\/\/.+\/ideas\/.+-(\d+)$/;
  var ideaUrl = ideaUrlPattern.exec(searchString);

  if (eventUrl !== null) {
    searchQuery.q = eventUrl[1];
    searchQuery.contentType = 'event';
  }

  if (productUpdateUrl !== null) {
    searchQuery.q = productUpdateUrl[1];
    searchQuery.contentType = 'productUpdate';
  }

  if (ideaUrl !== null) {
    searchQuery.q = ideaUrl[1];
    searchQuery.contentType = 'ideation';
  }

  var m = /https?:\/\/.+\/.+-\d+\/.+-(\d+)$/.exec(searchString);

  if (m !== null) {
    searchQuery.q = m[1];
  }

  return searchQuery;
};

var noop = function noop() {
  return {};
};

var submitIcon = function submitIcon(type) {
  switch (type) {
    case 'add':
      return (0, _preact.h)(_Add.default, {
        width: 16,
        height: 16,
        fill: "currentColor"
      });

    default:
      return (0, _preact.h)(_Search.default, {
        width: 16,
        height: 16,
        fill: "currentColor"
      });
  }
};

var SearchBox = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(SearchBox, _Component);

  var _super = _createSuper(SearchBox);

  function SearchBox() {
    var _this;

    (0, _classCallCheck2.default)(this, SearchBox);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "input", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setRef", function (input) {
      _this.input = input;
    });
    return _this;
  }

  (0, _createClass2.default)(SearchBox, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (!this.input) return;
      if (!this.props.focusOnMount) return;
      this.input.focus();
      setTimeout(function () {
        if (_this2.input) {
          _this2.input.focus();
        }
      }, 100);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(previousProps) {
      var _this3 = this;

      if (previousProps.enableFocusToSearch !== this.props.enableFocusToSearch && this.props.enableFocusToSearch && this.input) {
        this.input.focus();
        setTimeout(function () {
          if (_this3.input) {
            _this3.input.focus();
          }
        }, 100);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props = this.props,
          _this$props$reset = _this$props.reset,
          reset = _this$props$reset === void 0 ? noop : _this$props$reset,
          _this$props$clearSele = _this$props.clearSelection,
          clearSelection = _this$props$clearSele === void 0 ? noop : _this$props$clearSele,
          _this$props$refine = _this$props.refine,
          refine = _this$props$refine === void 0 ? noop : _this$props$refine,
          _this$props$setHighli = _this$props.setHighlightedIndex,
          setHighlightedIndex = _this$props$setHighli === void 0 ? noop : _this$props$setHighli,
          _this$props$inputValu = _this$props.inputValue,
          inputValue = _this$props$inputValu === void 0 ? '' : _this$props$inputValu,
          _this$props$getInputP = _this$props.getInputProps,
          getInputProps = _this$props$getInputP === void 0 ? noop : _this$props$getInputP,
          _this$props$openMenu = _this$props.openMenu,
          openMenu = _this$props$openMenu === void 0 ? noop : _this$props$openMenu,
          _this$props$isOpen = _this$props.isOpen,
          isOpen = _this$props$isOpen === void 0 ? false : _this$props$isOpen,
          _this$props$isControl = _this$props.isControl,
          isControl = _this$props$isControl === void 0 ? false : _this$props$isControl,
          _this$props$placehold = _this$props.placeholder,
          placeholder = _this$props$placehold === void 0 ? '' : _this$props$placehold,
          _this$props$updateSea = _this$props.updateSearch,
          updateSearch = _this$props$updateSea === void 0 ? noop : _this$props$updateSea,
          submitIconType = _this$props.submitIconType,
          newStyle = _this$props.newStyle,
          withoutRedirect = _this$props.withoutRedirect,
          className = _this$props.className;
      return (0, _preact.h)(_phrase.default, {
        p: "live.search.placeholder",
        renderAsText: true
      }, function (translatedPlaceholder) {
        return (0, _preact.h)("div", {
          className: (0, _classnames.default)('search-box', {
            'search-box--open': isOpen
          }, className)
        }, (0, _preact.h)(_phrase.default, {
          p: "accessibility_label.enter",
          renderAsText: true
        }, function (accessibilityLabel) {
          return (0, _preact.h)("button", {
            type: "submit",
            "aria-label": accessibilityLabel,
            className: "search-box__submit",
            onClick: function onClick(e) {
              e.preventDefault();
              doSearch(inputValue);
            } // data-toggle for Downshift component. This will keep the dropdown open and move focus to next "focusable" element
            ,
            "data-toggle": "button"
          }, submitIcon(submitIconType !== null && submitIconType !== void 0 ? submitIconType : ''));
        }), (0, _preact.h)(_phrase.default, {
          p: "accessibility_label.search",
          renderAsText: true
        }, function (accessibilityLabel) {
          return (0, _preact.h)("input", (0, _extends2.default)({
            ref: _this4.setRef,
            "aria-label": accessibilityLabel,
            type: "search",
            placeholder: isControl ? placeholder : translatedPlaceholder,
            autoComplete: "off",
            autoCorrect: "off",
            autoCapitalize: "off",
            "data-track-type": "click keydown",
            "data-element-name": "Search input",
            "data-event-filter": "enterKeydownFilter",
            className: (0, _classnames.default)('search-box__input', {
              'search-box--new-style': newStyle,
              'search-box__input--focused': inputValue && isOpen
            })
          }, getInputProps({
            onChange: function onChange(e) {
              var searchQuery = getSearchQueryFromInput(e.target.value);
              updateSearch(searchQuery, function () {
                refine(searchQuery.q);
                setHighlightedIndex(-1);
              });
            },
            onKeyDown: function onKeyDown(e) {
              if (e.keyCode === 13) {
                e.preventDefault();

                if (!withoutRedirect) {
                  doSearch(inputValue);
                }
              }
            },
            onSubmit: function onSubmit(e) {
              e.preventDefault();
              doSearch(inputValue);
            },
            onFocus: function onFocus() {
              eventTracker();
              openMenu();
            },
            // Since we dont have a label for the search input textbox
            'aria-labelledby': null
          })));
        }), (0, _preact.h)(_phrase.default, {
          p: "accessibility_label.clear_search",
          renderAsText: true
        }, function (accessibilityLabel) {
          return (0, _preact.h)("button", {
            type: "reset",
            "aria-label": accessibilityLabel,
            className: "search-box__reset",
            onClick: function onClick() {
              var _this4$input;

              clearSelection();
              reset();
              (_this4$input = _this4.input) === null || _this4$input === void 0 ? void 0 : _this4$input.focus();
            },
            style: {
              opacity: inputValue ? 1 : 0
            } // data-toggle for Downshift component. This will keep the dropdown open and move focus to next "focusable" element
            ,
            "data-toggle": "button"
          }, (0, _preact.h)(_Cancel.default, {
            width: 16,
            height: 16,
            fill: "currentColor"
          }));
        }));
      });
    }
  }]);
  return SearchBox;
}(_preact.Component);

exports.SearchBox = SearchBox;